import { IMAGESMAP, PRODUCT_IMAGES } from "../utils/imagesMap"

import { VIDEOMAP } from "../utils/videoMap"

import { lindsey, terry, ensley, dawnte } from "./data_results_nova_redesign"
import { joanna, jamie, katie } from "./data_results_ugc"

import AtomMobile from "../assets/icons/nova/gwp/atom-small.svg"
import PillMobile from "../assets/icons/nova/gwp/pill-small.svg"
import StudyMobile from "../assets/icons/nova/gwp/study-small.svg"

export const data = {
  seo: {
    title: "Nutrafol Core for Women",
    description:
      "Nutrafol Core for Women increases hair growth, hair quality, and overall health. Learn more about the benefits that Nutrafol women see.",
  },
  atcAreaData: {
    copy: "Designed for women 18-44<br class='block md:hidden'/> experiencing hair thinning.",
    tags: [
      "Gluten-free",
      "Dairy-free",
      "Hormone-free",
      "Gelatin-free",
      "Free of artificial colors",
      "Free of artificial flavoring",
      "Soy-free",
      "Drug-free",
      "Non-GMO tested",
    ],
    questions: [
      {
        title: "Benefits:",
        answer: [
          "Visibly thicker hair volume<sup>2</sup>",
          "Visibly less hair shedding<sup>2</sup>",
          "Hair that grows faster, stronger, and longer<sup>1,2</sup>",
        ],
      },
      {
        title: "Women also reported:",
        answer: [
          "Visibly thicker lashes and brows<sup>2</sup>",
          "Reduced feelings of stress and supported sleep quality<sup>2</sup>",
        ],
      },
    ],
    icons: [
      {
        iconMobile: AtomMobile,
        title: "Clinically proven formula",
      },
      {
        iconMobile: PillMobile,
        title: "100% drug-free ingredients",
      },
      {
        iconMobile: StudyMobile,
        title: "Get results in 3-6 months",
      },
    ],
    gwpData: {
      lineImage:
        "https://images.ctfassets.net/0rbfqd9c4jdo/JLCPXuUw2rJ96kVc2tVei/53f3c4996ea28d152ead3b4c092e4d43/dotted-line.png?fl=progressive",
      planeImage:
        "https://images.ctfassets.net/0rbfqd9c4jdo/6VjEY9F0VaznMTekFOASon/2ade566625df4b750343252ade22d9df/plane-straight-line-mb.png?fl=progressive",
      tag: {
        line: "Limited Time Only",
        classes: "",
      },
      card: {
        heading: "FREE travel kit /$66 value<sup>‡</sup>",
        copy: "with a 3- or 6-month subscription.",
        containerClasses: "justify-center",
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/4CFzXenCiB4va0krrxNxAd/64bc3403815e70a26abb8c5e6bebe8a3/travel-kit-gwp-women.png?fl=progressive",
        button: {
          level: "Textlink",
          label: "Learn More",
          icon: "Right",
        },
      },
      atcCard: {
        heading: "FREE Travel Kit / $66 value<sup>‡</sup>",
        copy: "Delivered once with your 3- or 6-month subscription, while supplies last.",
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/5EJZwBiS9t4huZCovYyr31/4c1811b77c9e9aa24df8082653f01f95/gwp-travelkit-lifestyle.jpg?fl=progressive",
      },
      modal: {
        title: "Free TSA-friendly travel kit / $66 value.<sup>‡</sup>",
        headline:
          "Sign up for a 3- or 6-month<br class='block sm:hidden lg:block' /> subscription to receive:",
        items: [
          "7-Day Capsule Case",
          "2 oz Root Purifier Shampoo",
          "2 oz Strand Defender Conditioner",
          "5 mL Hair Serum",
          "Silk Scrunchie",
          "Travel Pouch",
        ],
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/31zZmxL1ot2R2jq9ybewlh/d3c5d230fd37c1fc16fd6357a1b4bb65/gwp-travel-kit-2025-women.jpg?fl=progressive",
        terms:
          "‡Limited time only. One per customer; cannot be combined with other offers or sales. Requires new Hair Growth Nutraceutical subscription created on nutrafol.com with recurring delivery and payment every 3 or 6 months per offered gift. New subscribers only. Gift is a one-time delivery only. Gifts are non-refundable or otherwise exchangeable for cash or product.",
      },
    },
    name: "Nutrafol Women",
    superScript: "1-3",
    booster: false,
    coreCategory: "Women",
    containerSize: "120 CAPSULES",
    dailyDosage: "4 CAPSULES",
    pagePath: "/nutrafol-core-for-women/",
    title: "Women",
    subtitle: `Our physician-formulated hair growth supplement is designed for women 18-44 experiencing hair thinning. We use a clinically proven formula and standardized ingredients to target key root causes of thinning, such as stress, lifestyle and nutrition. This award-winning formula supports faster-growing, visibly thicker, fuller, stronger hair. And, it's a seamless addition to your daily wellness routine: just 4 capsules, once a day for results in 3-6 months.<sup>1,2</sup>`,
    mainimg: PRODUCT_IMAGES.WOM1.label4,
    shoppingImg: PRODUCT_IMAGES.WOM1.label1,
    supplement_label: PRODUCT_IMAGES.WOM1.label0,
    options: [
      {
        sku: "WOM1-S01",
        title: "Monthly Delivery",
        subtitle:
          "Consistency is key. Stay on track with easy monthly delivery and save.",
        text_description: "A 1-month supply each month.",
        savings: "Save 10%",
        text: "Pause or cancel anytime. ",
        shippingText: "Free shipping. Pause or cancel anytime.",
        description: {
          header: "Make sure you've got what you need every month, worry-free!",
          includedTitle: "You’ll also get:",
          benefits: [
            {
              text: "Free shipping every 30 days. No need to count your capsules or remind yourself to order.",
            },
            {
              textA: "1-on-1 phone consultations with ",
              linkText: "Nutrafol naturopathic doctors",
              linkPath: "/hair-analysis/",
              textB:
                " for personalized growth guidance whenever you need it. A $150 value. (Optional)",
            },
            {
              textA: "Complimentary ",
              linkText: "Hair Mineral Analysis",
              linkPath: "/hair-analysis/",
              textB: " to monitor your hair’s needs. A $200 value. (Optional)",
            },
            {
              text: "Flexible auto-shipments. Change your ship dates and subscription status online any time.",
            },
          ],
        },
      },
      {
        sku: "WOM3-S01",
        title: "3-Month Delivery",
        id: "threemonthsubrefill",
        valueCopy: "Recommended",
        selected: true,
        subtitle: "A 3-month supply every 3 months.",
        subtitle2: "($224 billed every 3 months)",
        text_description:
          "A 3-month supply with refills delivered every 3 months.",
        savings: "Save 15%",
        savings_alt: "Save 5%",
        old_price_alt: "237",
        code: "WOMTRAVELGWP",
        text: "Pause or cancel anytime. ",
        shippingText: "Free shipping. Pause or cancel anytime.",
        shippingTextAlt:
          "<span class='line-through text-master-base-alt-alt mr-2'>$79 per month</span> $74 per month",
        description: {
          header: "Make sure you've got what you need every month, worry-free!",
          includedTitle: "You’ll also get:",
          benefits: [
            {
              text: "Stay on track for hair growth success with auto-delivery.",
            },
            {
              text: "Free consultations with a naturopathic doctor for personalized guidance as you grow.",
            },

            {
              text: "Keep it easy and planet-friendly with fewer shipments.",
            },
            {
              text: "Pause or cancel anytime.",
            },
            {
              text: "Free US shipping.",
            },
          ],
        },
      },
      {
        sku: "WOM6-S01",
        title: "6-Month Delivery",
        id: "sixmonthsubrefill",
        valueCopy: "Recommended",
        selected: true,
        subtitle: "A 6-Month supply every 6 months.",
        subtitle2: "($422 billed every 6 months)",
        text_description:
          "A 6-month supply with refills delivered every 6 months.",
        savings: "Save 20%",
        savings_alt: "Save 10%",
        old_price_alt: "474",
        code: "WOMTRAVELGWP",
        text: "Pause or cancel anytime. ",
        shippingText: "Free shipping. Pause or cancel anytime.",
        shippingTextAlt:
          "<span class='line-through text-master-base-alt-alt mr-2'>$79 per month</span> $70 per month",
        description: {
          header: "Make sure you've got what you need every month, worry-free!",
          includedTitle: "You’ll also get:",
          benefits: [
            {
              text: "Stay on track for hair growth success with auto-delivery.",
            },
            {
              text: "Free consultations with a naturopathic doctor for personalized guidance as you grow.",
            },

            {
              text: "Keep it easy and planet-friendly with fewer shipments.",
            },
            {
              text: "Pause or cancel anytime.",
            },
            {
              text: "Free US shipping.",
            },
          ],
        },
      },
      {
        sku: "WOM1-N01",
        title: "Single Bottle",
        subtitle: "Order by the bottle. <br>(Best for stocking up.)",
        text_description: "A 1-month supply delivered once.",
        text: "",
        shippingText: "+$6.95 shipping.",
      },
    ],
    singleOption: {
      sku: "WOM1-N01",
      title: "Single Bottle",
      id: "singlepurchase",
      subtitle: "A 1-month supply delivered once.",
      text_description: "A 1-month supply delivered once.",
      subtitle2:
        "Nutrafol is meant to be taken daily at full dosage long-term. Results can be expected after 3-6 months.",
      text: "A 1-month supply delivered once.  Free US shipping.",
      shippingText: "+$6.95 shipping.",
    },

    images: [
      "pdp-core-womens-main_new.jpg",
      "pdp-core-womens-ingredients-area.png",
      "pdp-core-womens-main-3.png",
      "pdp-core-womens-main-laura.png",
      "pdp-core-womens-main-tia.png",
    ],
    imageArea: [
      {
        image: IMAGESMAP.AREAWOMEN.REDESIGN_INGR,
        name: "",
        alt: "Standardized vitamins, minerals, and natural ingredients for consistently reliable results—always.",
      },
      {
        name: "Avery",
        description: "Taking <span>Women Hair Growth Nutraceutical</span>",
        image: IMAGESMAP.AREAWOMEN.REDESIGN_VIDEO1,
        video: VIDEOMAP.WOMEN.AVERY,
        preload: "auto",
      },
      {
        name: "Sheila",
        description: "Taking <span>Women Hair Growth Nutraceutical</span>",
        image: IMAGESMAP.AREAWOMEN.REDESIGN_VIDEO2,
        video: VIDEOMAP.WOMEN.SHEILA,
        id: "sheila-video",
        video_name: "Sheila Influencer Video",
      },
      {
        slider: {
          slides: [
            {
              stat: "90%",
              copy: "of women saw overall improvement in their hair after 6 months.<sup>1</sup>",
            },
            {
              stat: "84%",
              copy: "of women saw less shedding after 6 months.<sup>1</sup>",
            },
          ],
        },
      },
      {
        image: IMAGESMAP.AREAWOMEN.REDESIGN_BEFORE,
        name: "Before",
        alt: "Before",
      },
      {
        image: IMAGESMAP.AREAWOMEN.REDESIGN_AFTER,
        alt: "After - In a 6-month clinical study, participants taking Nutrafol Women experienced significant hair growth.",
        name: "After",
      },
      {
        name: "sts",
        id: "sts-women-imagearea",
        title:
          "This is about <span class='font-grilliItalic'>so much more</span> than hair.",
        stats: [
          {
            title: "2/3",
            copy: "agree that the way their hair looks can completely change how they feel about themselves.*",
          },
          {
            title: "45%",
            copy: "revealed their hair thinning has negatively impacted their self-confidence.*",
          },
          {
            title: "15x<span class='br'></span> a day",
            copy: "How often the average woman experiencing hair thinning is preoccupied with thoughts about the issue.*",
          },
        ],
      },
      {
        image: IMAGESMAP.AREAWOMEN.REDESIGN_PILL,
        name: "Pill",
      },
      {
        image: IMAGESMAP.AREAWOMEN.REDESIGN_PACKAGE,
        name: "Packaging",
      },
    ],
    badgeArea: [
      {
        badge: "xhdpi_hp-recommended-allure-color.png.png",
        text: "Winner of a 2018 Best of Beauty Breakthrough award from beauty authority, Allure Magazine.",
        alt: "Allure, the beauty expert, breakthrough award.",
      },
      {
        badge: "xhdpi_Nutrafol-Reco-Emblem-Dark.png",
        text: "Grow with the brand loved by leading dermatologists.",
        alt: "Number one dermatologist recommended hair growth supplement brand*.",
      },
    ],
  },
  rootCauses: {
    title:
      "Targets 6 key root causes of <span class='whitespace-nowrap font-grilliItalic'>hair thinning.</span>",
    subtitle:
      "Our proprietary blend pinpoints key root causes of hair thinning and shedding<br class='hidden lg:block' /> to promote a healthy hair growth cycle—because hair and health grow together.",
    causes: [
      {
        name: "Hormones",
        shortDescription:
          "DHT sensitivity can be caused by genetics, stress, poor diet, and toxins.",
        longDescription:
          "Throughout life, our hormones are ever-changing, shifting, and sometimes out of balance. DHT (Dihydrotestosterone) is a hormone known to cause hair follicles to shrink with age and eventually close completely—especially when imbalanced.",
        value: 8,
      },
      {
        name: "Stress",
        shortDescription:
          "Physical or emotional stress like giving birth or a demanding job.",
        longDescription:
          "A busy lifestyle can lead to prolonged stress, a root cause shown to make hair follicles shift from a growth state to a rest state. If not addressed, the follicle may receive a signal to prematurely stop growing, compromising the health of your hair and resulting in unwanted excess shedding.",
        value: 10,
      },
      {
        name: "Lifestyle",
        shortDescription:
          "Refers to your surroundings, the products you use, and the foods you eat.",
        longDescription:
          "Through a process called oxidative stress, environmental triggers (like your everyday surroundings, the food you eat, the drinks you consume, and certain products you use) can impact the hair follicles and weaken their ability to produce and grow hair.",
        value: 9,
      },
      {
        name: "Metabolism",
        shortDescription:
          "Influences how hair follicles receive nutrients from the body.",
        longDescription:
          "Breakage and hair that is not growing how you expect can be signs of cellular metabolism impacting your hair. Changes in metabolism-whether through age or diet-can shorten the hair growth phase, affecting its ability to grow in the natural hair cycle.",
        value: 7,
      },
      {
        name: "Nutrition",
        shortDescription:
          "Nutrient gaps that can result from a poor diet or a compromised gut microbiome.",
        longDescription:
          "The body requires nourishment via proper nutrients—nutrients that support a healthy growth cycle. These can be further impacted by stress, affecting the hair’s strength and overall health. But by supporting whole-body health, you support growth.",
        value: 3,
      },
      {
        name: "Aging",
        shortDescription:
          "Aging reduces the scalp’s collagen and elastin, weakening its grip on hair strands.",
        longDescription:
          "The aging process is an unavoidable part of life and, starting in our 20s, we begin to notice its effects. As it pertains to hair, aging can cause thinning, excess shedding, as well as affect the overall health of hair.",
        value: 6,
      },
    ],
  },
  stories: {
    heading: "The hair growth results you've been waiting for.",
    headingMaxWidths: ["311px", "311px", "450px", "575px", "100%"],
    stories: [
      {
        videoPoster:
          "https://images.ctfassets.net/0rbfqd9c4jdo/1CdahSTmWsWyBp8gPXWUiD/422bdcccfe64c823b3eb4d1779e2020f/Supers-Victoria-Desktop.png",
        video:
          "https://nutrafol.com/media/video_storage/VICTORIA_MASTER_SUBS_720P_OPTIMIZED.mp4",
        name: "Victoria",
        quote:
          "I thought about my hair thinning 24/7. I felt very insecure. After taking Nutrafol, my scalp started to fill in. To start to see the little curls come back was amazing. Knowing I don’t have to worry about my hair anymore is really empowering.",
        product: "Nutrafol Women Hair Growth Nutraceutical",
        duration: "4.5 years",
        linkToPdp: false,
        linkTo: "/nutrafol-core-for-women/",
        text: "Taking Nutrafol Women Hair Growth Nutraceutical for 4.5 years",
      },
      {
        videoPoster:
          "https://images.ctfassets.net/0rbfqd9c4jdo/5ohUBMNMyNX6PYRpNOsRSv/1272bed2ec8c21abdfa2f6ce4765f8f5/Supers-Laura-Desktop.png",
        video:
          "https://nutrafol.com/media/video_storage/LAURA_MASTER_SUBS_720P_OPTIMIZED.mp4",
        name: "Laura",
        quote:
          "Nutrafol has turned my hair around. It’s much thicker and longer than it has been in a very long time.",
        product: "Nutrafol Women Hair Growth Nutraceutical",
        duration: "2 years",
        linkToPdp: false,
        linkTo: "/nutrafol-core-for-women/",
        text: "Taking Nutrafol Women Hair Growth Nutraceutical for 2 years",
      },
    ],
  },
  results: {
    pt: [0],
    pb: [0],
    header: {
      breakpoint: 9999,
      title: {
        maxWidth: 1152,
        text: `Over ${process.env.GATSBY_NUTRAFOL_GROWING_NUMBER} million people are tapping into their growth potential. <span class='font-grilliItalic whitespace-nowrap'>Join them.</span>`,
      },
    },
    slider: {
      cardDirection: "row",
      showDisclaimer: false,
      slides: [lindsey, terry, ensley, dawnte],
    },
    footerDisclaimer:
      "In a 6-month clinical study, participants taking Nutrafol Women Hair Growth Nutraceutical experienced significant hair growth compared to those in the placebo group.",
  },
  ingredients: {
    name: "Nutrafol Women",
    complex: {
      title: "Synergen Complex&reg;",
      list: [
        {
          name: "Sensoril<sup>&reg;</sup> Ashwagandha",
          image:
            "https://images.ctfassets.net/0rbfqd9c4jdo/2H92fWyhykbNpg7nRaPs3F/af2def99a2cc5bf03b215a15082be6ea/sensoril-ashwagandha_3-2.jpg?fl=progressive",
          target: "Anti Shedding",
          description:
            "A botanical shown to lower cortisol levels for stress relieving benefits to reduce hair shedding.",
        },
        {
          name: "Saw Palmetto",
          image:
            "https://images.ctfassets.net/0rbfqd9c4jdo/6SEdI8xfk61qUxcmSVVrdo/a307318a99c1c74d6d552bbf4615ca83/saw-palmetto_3-2.jpg?fl=progressive",
          target: "Anti-DHT",
          description:
            "Provides concentrated fatty acids, clinically shown to reduce the conversion of testosterone to DHT to improve hair growth.",
        },
        {
          name: "Tocotrienol Complex",
          image:
            "https://images.ctfassets.net/0rbfqd9c4jdo/4pkgkqQyyWo2XWtPQwO3np/7a88430f3eec5d5e385494b61e45f176/tocotrienol-complex_3-2.jpg?fl=progressive",
          target: "Densifying",
          description:
            "A concentrated form of vitamin E, an antioxidant that fights against environmental stress to improve hair density.",
        },
        {
          name: "Marine Collagen Peptides",
          image:
            "https://images.ctfassets.net/0rbfqd9c4jdo/6STDXZlZC4kp59F82oDwIs/dda42f57a086f950d219c6efa7b600c8/marine-collagen-peptides_3-2.jpg?fl=progressive",
          target: "Strengthening",
          description:
            "Peptides that provide the building blocks of strong hair fibers, while delivering hydration to the scalp.",
        },
        {
          name: "Curcumin",
          image:
            "https://images.ctfassets.net/0rbfqd9c4jdo/2Zqqvgp6RxnH2CVxTe8LKV/5bde6483bf80713e0084dd5d2ec0cb24/curcumin_3-2.jpg?fl=progressive",
          target: "Multi-targeting",
          description:
            "Extracted from turmeric for its antioxidant properties that fight free radicals to support cellular health.",
        },
      ],
    },
    keyActives: {
      title: "Other Key Actives",
      list: [
        {
          name: "Kelp Minerals",
          image:
            "https://images.ctfassets.net/0rbfqd9c4jdo/6zDBNZA0Tjorfb34cRQCKO/3c5110841a6202334ad157d35a608e65/kelp-minerals_3-2.jpg?fl=progressive",
          target: "Protecting",
          description:
            "A rich source of minerals (iodine) needed to support our hormones that manage hair growth rate.",
        },
        {
          name: "Resveratrol",
          image:
            "https://images.ctfassets.net/0rbfqd9c4jdo/5KoJj1zWTvqNq0f2KiLnuq/8fe229ea08721d5448476e582a2acaea/resveratrol_3-2.jpg?fl=progressive",
          target: "Protecting",
          description:
            "Provides antioxidant activity that promotes hair density by protecting the scalp from environmental damage.",
        },
        {
          name: "Horsetail",
          image:
            "https://images.ctfassets.net/0rbfqd9c4jdo/2dTPwhJnD703sqesDqIrk/562b76939f68c00e77f2b439a9a498d5/horsetail_3-2.jpg?fl=progressive",
          target: "Anti-breakage",
          description:
            "A natural source of silica, an essential mineral which promotes hair strength.",
        },
        {
          name: "Keratin",
          image:
            "https://images.ctfassets.net/0rbfqd9c4jdo/4nll5dJJcE7XYHkj1prCcd/7e2cbaa848a9f1a167bed491924f4cfd/keratin_3-2.jpg?fl=progressive",
          target: "Strengthening",
          description:
            "A form of protein that mimics keratin in the body to support damaged hair.",
        },
      ],
    },
    ingredients: {
      title: "Supporting Ingredients",
      list: [
        "L-Cysteine",
        "L-Lysine",
        "L-Methionine",
        "Black Pepper",
        "Capsicum",
        "Vitamin A",
        "Vitamin C",
        "Vitamin D",
        "Biotin ",
        "Zinc",
        "Selenium",
        "Hyaluronic Acid",
      ],
    },
  },
  faq: {
    heading:
      "We’re serious about facts. <br class='block lg:hidden min-[1350px]:block' />Ask away.",
    includeLinkToFaqPage: true,
    accordions: [
      {
        title: "When can I expect to see results?",
        content:
          "In our clinical study, women showed results in 3-6 months.<span class='font-dinamoMono block mt-[16px]'>1-3 Months</span>Strengthen hair from within. Look for shinier hair with less shedding and breakage.<span class='font-dinamoMono block mt-[16px]'>3-6 Months</span>You may notice improvement in fullness and volume.<span class='font-dinamoMono block mt-[16px]'>6+ Months</span>Experience visible changes like faster-growing hair that’s thicker and stronger.",
      },
      {
        title: "What affects women’s hair growth?",
        content:
          "For women, stress is a major root cause of poor hair growth. Hormones also play a significant role for women due to fluctuations throughout life, especially during and after childbirth when estrogen and progesterone decline and cortisol increases by over 200%. Follicles are also damaged by metabolic changes, nutritional deficits, and environmental exposure including overstyling, chemicals, and heat.",
      },
      {
        title: "Will Nutrafol work for my hair type?",
        content:
          "Nutrafol was formulated to promote hair growth for all types of hair. While the characteristics of hair strands may vary by ethnicity, the underlying root causes that affect hair follicles can affect all people equally.<br/><br/>In a recent clinical study, we examined the effectiveness of Nutrafol in African American, Asian, Hispanic, and Non Hispanic men and women. All ethnicities saw less shedding after two months and improved thickness, growth rate, scalp coverage, and shine after six months.",
      },
      {
        title: "Will hair grow on other parts of my body?",
        content:
          "No. Facial and body hair are triggered by different factors than the hair on our head. Saw Palmetto helps combat DHT, which may actually prevent facial hair growth.",
      },
      {
        title:
          "What are the main differences in formulas between Nutrafol Men, Women, Women's Vegan, Postpartum, and Women's Balance?",
        content: `
          Our Hair Growth Nutraceuticals are physician-formulated to the bio-specific needs of men and women through all life stages and lifestyles.† Key root causes of thinning hair affect men and women differently and can change over time—so we created multiple formulas to give your hair exactly what it needs, when it needs it most.<br/><br/>
          Women’s formula focuses on addressing key root causes of hair thinning for women 18-44 years old when stress, lifestyle habits and nutrition play a heightened role in hair health.<sup>†</sup><br/><br/>
          Women’s Vegan is formulated for women 18-44 with key root causes of thinning focusing on stress and lifestyle habits plus it is optimized to support plant-based diet’s nutrition and absorption of nutrients in the body that affect hair health.<sup>†</sup><br/><br/>
          Women’s Balance is formulated for women 45+ to support key root causes of hair thinning for women such as stress with optimized support for hormonal changes, such as menopause that affect hair health.<sup>†</sup><br/><br/>
          Postpartum is OBGYN-formulated to address key root causes of hair thinning and shedding for women within the first year of giving birth and through the time they are breastfeeding such as the physical and emotional stress, hormonal changes and nutritional support.<sup>†</sup><br/><br/>
          Men’s formula multi-targets key root causes of thinning for men 18+ such as stress and poor nutrition with optimized support of hair-growth inhibiting DHT hormone, without compromising sexual performance.<sup>†</sup>
        `,
      },
      {
        title: "How is Nutrafol different from other hair growth products?",
        content:
          "In short, we provide hair growth formulas that are personalized specifically for you and formulated with 100% drug-free vitamins, minerals, and natural ingredients backed by clinical studies and published ingredient research, whereas many supplements are not clinically tested. Other supplements have variable potency and are poorly absorbed.",
      },
    ],
  },
  references: {
    pt: ["40px", "40px", "48px", "80px"],
    pb: ["40px", "40px", "48px", "80px"],
    line1: `*According to the study led by Nutrafol in 2023 surveying a total of 2,000 women throughout North America.<br/>†${process.env.GATSBY_IQVIA_DATE}<br/>‡Limited time only. One per customer; cannot be combined with other offers or sales. Requires new Hair Growth Nutraceutical subscription created on nutrafol.com with recurring delivery and payment every 3 or 6 months per offered gift. New subscribers only. Gift is a one-time delivery only. Gifts are non-refundable or otherwise exchangeable for cash or product.<br/><br/>`,
    items: [
      "Ablon and Kogan. J Drugs Dermat. 2018.",
      "Stephens et al., JCAD 2022/Nutrafol Data on File, 2020.",
    ],
  },
}
